import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { BusinessLogService } from '../services/businessLog.service';

@Component({
  templateUrl: 'business-log.component.html',
  standalone: false
})
export class BusinessLogComponent implements OnInit, OnDestroy {
  businessId = 0;
  loglist: any[] = [];
  loginUsersByDay: Record<string, any[]> = {};
  loadingDays: Record<string, boolean> = {};
  private readonly destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private logs: BusinessLogService
  ) {}

  ngOnInit(): void {
    document.body.classList.remove('opened');
    this.businessId = Number(this.route.snapshot.parent.paramMap.get('bid'));
    this.loglist = this.route.snapshot.data['loglist'] ?? [];
  }

  loadUsers(row: any): void {
    const day = row.LogOn as string;
    if (this.loadingDays[day] || this.loginUsersByDay[day] !== undefined)
      return;
    this.loadingDays[day] = true;
    this.logs
      .getAllLogsUserName(this.businessId, day)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loadingDays[day] = false;
        })
      )
      .subscribe({
        next: users => {
          this.loginUsersByDay[day] = users;
        },
        // The shared interceptor presents the failure. Leave the day uncached so expansion can retry.
        error: () => {}
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    document.body.classList.add('opened');
  }
}
